










import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop } from 'vue-property-decorator'
import { adminUserWalletLogTableColumn } from '@/modules/wallet-log/models/columns/admin-user-wallet-log-table.column'
import AdminUserWalletLogTableRow from '@/modules/wallet-log/components/admin/table/AdminUserWalletLogTableRow.vue'
import QTable from 'quasar/src/components/table/QTable.js';
import { WalletLogCollectionModel } from '@/modules/wallet-log/models/admin-wallet-log-collection.model'

@Component({
  components: {
    TesTable
  }
})
export default class AdminUserWalletLogTable extends Vue {
  @Prop({ required: true }) logsData: WalletLogCollectionModel[]
  @Prop({ default: adminUserWalletLogTableColumn }) columns: QTable['columns']
  @Prop({ default: () => AdminUserWalletLogTableRow }) rowComponent
}
